<template>
  <h3
    id="`filter-${attribute}-label`"
    class="mb-2.5 text-sm font-bold"
  >
    <span class="sr-only">Filter by</span> {{ name }}
  </h3>
</template>
<script lang="ts">
export default { name: 'RefinementHeading' }
</script>
<script lang="ts" setup>
defineProps<{
  name: string,
  attribute: string,
}>()
</script>
